import React, { useState, useEffect } from 'react';
import { FaVideo, FaMousePointer, FaPoll, FaBell } from 'react-icons/fa';
import './task.css';

const TaskPage = () => {
  const tasks = [
    { id: 1, title: 'Watch Video Ad 1', description: 'Watch a 30-second ad to earn $0.10', type: 'video', url: 'https://www.youtube.com/' },
    { id: 2, title: 'Click on Ad 1', description: 'Click on an ad and explore for 30 seconds', type: 'click', url: 'https://example.com/ad1' },
    { id: 3, title: 'Survey 1', description: 'Complete a short survey to earn $0.50', type: 'survey', url: 'https://example.com/survey1' },
    { id: 4, title: 'Watch Video Ad 2', description: 'Watch another video ad and earn $0.10', type: 'video', url: 'https://example.com/video-ad2' },
    { id: 5, title: 'Click on Ad 2', description: 'Explore another ad for 30 seconds', type: 'click', url: 'https://example.com/ad2' },
    { id: 6, title: 'Survey 2', description: 'Another survey to earn $0.50', type: 'survey', url: 'https://example.com/survey2' },
    { id: 7, title: 'Watch Video Ad 3', description: 'Earn more by watching this video ad', type: 'video', url: 'https://example.com/video-ad3' },
    { id: 8, title: 'Click on Ad 3', description: 'Another ad to explore for earnings', type: 'click', url: 'https://example.com/ad3' },
    { id: 9, title: 'Survey 3', description: 'Complete this survey for extra earnings', type: 'survey', url: 'https://example.com/survey3' },
    { id: 10, title: 'Exclusive Video Ad', description: 'Special ad that earns you more', type: 'video', url: 'https://example.com/video-ad4' }
  ];

  // State
  const [completedTaskIds, setCompletedTaskIds] = useState(() => {
    const saved = localStorage.getItem('completedTaskIds');
    return saved ? JSON.parse(saved) : [];
  });

  const [currentPage, setCurrentPage] = useState(1);
  const tasksPerPage = 5;

  // Derived state
  const pendingTasks = tasks.length - completedTaskIds.length;
  const completedTasks = completedTaskIds.length;

  // Pagination logic
  const indexOfLastTask = currentPage * tasksPerPage;
  const indexOfFirstTask = indexOfLastTask - tasksPerPage;
  const currentTasks = tasks.slice(indexOfFirstTask, indexOfLastTask);
  const totalPages = Math.ceil(tasks.length / tasksPerPage);

  // Save to localStorage when completedTaskIds changes
  useEffect(() => {
    localStorage.setItem('completedTaskIds', JSON.stringify(completedTaskIds));
  }, [completedTaskIds]);

  const handleTaskClick = (task) => {
    if (completedTaskIds.includes(task.id)) return;

    window.open(task.url, '_blank');
    setCompletedTaskIds([...completedTaskIds, task.id]);
  };

  const getTaskIcon = (type) => {
    switch (type) {
      case 'video':
        return <FaVideo size={20} color="#ff9800" />;
      case 'click':
        return <FaMousePointer size={20} color="#007bff" />;
      case 'survey':
        return <FaPoll size={20} color="#4caf50" />;
      default:
        return null;
    }
  };

  return (
    <div className="task-page">
      <header className="task-header">
        <h1>Earn Money by Completing Tasks</h1>
        <div className="notification-icon">
          <FaBell size={24} color="#00e676" />
          <span className="task-count">{pendingTasks} Pending | {completedTasks} Completed</span>
        </div>
      </header>

      <div className="task-list">
        {currentTasks.map(task => (
          <div key={task.id} className={`task-card ${completedTaskIds.includes(task.id) ? 'completed' : ''}`}>
            <h2 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {getTaskIcon(task.type)} {task.title}
            </h2>
            <p>{task.description}</p>
            <button
              disabled={completedTaskIds.includes(task.id)}
              onClick={() => handleTaskClick(task)}
            >
              {completedTaskIds.includes(task.id) ? 'Completed' : 'Start Task'}
            </button>
          </div>
        ))}
      </div>

      <div className="pagination">
        <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>Previous</button>
        <span>Page {currentPage} of {totalPages}</span>
        <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
      </div>
    </div>
  );
};

export default TaskPage;
